import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { addTeamToFeatureFlag } from "./schema/add-team-to-feature-flag";
import { getAnalyticsInsightReports } from "./schema/analytics/get-analytics-insight-reports";
import { getProductInsights } from "./schema/analytics/get-product-insights";
import { getProductsBasicInfo } from "./schema/analytics/get-products-basic-info";
import { getReturnsInsightInfo } from "./schema/analytics/get-returns-insight-info";
import { provideInsightReportFeedback } from "./schema/analytics/provide-insight-report-feedback";
import { checkSession } from "./schema/check-session";
import { deleteRole } from "./schema/delete-role";
import { getCurrentIncidents } from "./schema/get-current-incidents";
import { getEnabledPlatforms } from "./schema/get-enabled-platforms";
import { getFeatureFlag } from "./schema/get-feature-flag";
import { getTeamUsers } from "./schema/get-team-users";
import { getUserOnboarding } from "./schema/get-user-onboarding";
import { getUserPermissions } from "./schema/get-user-permissions";
import { getUserRolesOnTeam } from "./schema/get-user-roles-on-team";
import { upsertUserOnboarding } from "./schema/upsert-user-onboarding";
import { upsertUserRole } from "./schema/upsert-user-role";

export const rpcDefinition = {
  addTeamToFeatureFlag,
  checkSession,
  deleteRole,
  getCurrentIncidents,
  getFeatureFlag,
  getTeamUsers,
  getUserOnboarding,
  getUserPermissions,
  getUserRolesOnTeam,
  getEnabledPlatforms,
  upsertUserOnboarding,
  upsertUserRole,
  getAnalyticsInsightReports,
  provideInsightReportFeedback,
  getProductInsights,
  getReturnsInsightInfo,
  getProductsBasicInfo,
};

export type RedoPlatformRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
